import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Checkmark16 } from '@ingrid/iconography/react';
import { Button, Modal, RadioList } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { AppFetchConfig } from '~src/main/config';

import { AppLanguages, DefaultLanguage } from './i18n-config';

interface Props {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
}
export function LanguageSelector({ open, setOpen }: Props) {
  const { i18n, t } = useTranslation();
  const [selectedLang, setSelectedLang] = useState<string>(i18n.resolvedLanguage ?? DefaultLanguage.code);
  const formMethods = useForm();

  const close = () => {
    setOpen(false);
    setTimeout(() => (document.body.style.pointerEvents = 'auto')); // hack, pointer-events: none isn't being removed when closing
  };

  const onSubmit = () => {
    close();

    i18n
      .changeLanguage(selectedLang)
      .then(() => localStorage.setItem('lng', selectedLang))
      .catch(error => console.error(error));
  };

  return (
    <Modal.Root onOpenChange={close} open={open}>
      <Modal.Content style={{ width: '480px' }}>
        <Modal.Header title={t('topBar.changeLanguage')} />
        <Modal.Body>
          <form id="form-language-selector" onSubmit={formMethods.handleSubmit(onSubmit)}>
            <RadioList.Root onValueChange={lng => setSelectedLang(lng)} value={selectedLang}>
              {AppLanguages.map(lng => (
                <RadioList.Item key={lng.code} value={lng.code}>
                  <img
                    width={24}
                    height={24}
                    src={`${AppFetchConfig.cdnUrl}/static/country-flags/${lng.code.split('-')[1].toLowerCase()}.svg`}
                  />
                  {lng.nativeName}
                  <RadioList.Indicator>
                    <Checkmark16 />
                  </RadioList.Indicator>
                </RadioList.Item>
              ))}
            </RadioList.Root>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Modal.CloseButton>
            <Button variant="secondary">{t('common.cancel')}</Button>
          </Modal.CloseButton>
          <Button form="form-language-selector" type="submit">
            {t('common.submit')}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
}
